module.exports = __webpack_public_path__ + "img/blueprint-grey.2a1e086f.jpg";